module.exports = __webpack_public_path__ + "static/img/manual_zh_14.c09811d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_14.png
// module id = Mm6R
// module chunks = 4